import { aiService } from "Apis";
import { ApiChartPayload } from "@incendium/api";
import { parseChartPayloadToIChart } from "features/chartLibrary/utils";

export const generateChart = async (prompt: string, projectId: number) => {
  const response = await aiService.aiServiceGenerateChart({
    projectId,
    body: {
      prompt,
    },
  });
  return parseChartPayloadToIChart(response.chart?.chart as ApiChartPayload);
};
